module.exports = __webpack_public_path__ + "static/003-b236e66d768d37168364c77ce0d3a355.png";